<script setup lang="ts">
import { useElementBounding } from "@vueuse/core";
import { computed, useTemplateRef, watch } from "vue";
import { useThemeStore } from "#/store/theme";

const themeStore = useThemeStore();

const el = useTemplateRef("el");
const isVisible = computed(() => themeStore.data?.system_notification_text?.length);
const { height } = useElementBounding(el);

watch(height, (newHeight) => {
	document.body.style.setProperty("--system-notification-height", `${newHeight || 0}px`);
});
</script>

<template>
	<div v-if="isVisible" ref="el" class="system_notification">{{ themeStore.data?.system_notification_text }}</div>
</template>

<style lang="scss" scoped>
  @use './systemNotification.scss';
</style>
